import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@sb/ui/button';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-downgrade-intro',
  imports: [TranslatePipe, ButtonComponent],
  templateUrl: './downgrade-intro.component.html',
})
export class DowngradeIntroComponent {
  planName = input<string>();

  // Free flow (from trial-expired): the downgrade hasn't happened yet, so we frame it as upcoming
  // rather than claiming the account was already downgraded.
  isFreeDowngrade = input(false);

  next = output<void>();
}
